import { render, staticRenderFns } from "./Specifics.vue?vue&type=template&id=0792050e&scoped=true&"
import script from "./Specifics.vue?vue&type=script&lang=js&"
export * from "./Specifics.vue?vue&type=script&lang=js&"
import style0 from "./Specifics.vue?vue&type=style&index=0&id=0792050e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0792050e",
  null
  
)

export default component.exports